import { Box, SxProps, Typography } from "@mui/material";
import { StyleRules } from "@mui/styles";

interface InfoProps {
  text: string;
  inlineTitle?: boolean;
  sx?: SxProps;
  style?: StyleRules;
}

const Info = ({ text, inlineTitle, sx, style }: InfoProps) => {
  if (text.length === 0) {
    return null;
  }
  const info = text.trim();
  if (inlineTitle) {
    return (
      <Box sx={{ height: "100%", display: "flex", alignItems: "flex-end", paddingBottom: 1, ...sx }}>
        <Typography variant="subtitle2">{info}</Typography>
      </Box>
    );
  }
  return (
    <pre style={{ margin: 0, whiteSpace: "break-spaces", ...style }}>
      <Typography variant="body2">{info}</Typography>
    </pre>
  );
};

export default Info;
